import { CodeBlock, dracula } from "react-code-blocks";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";

interface propsType {
  move: any;
}

const request_code: string = `import axios from "axios";

const requestPost => async (requestBody: any) => {
  let header: any = { "Content-Type": "application/json" };
  const response = await axios.post(<USER API URL>, requestBody, header);
  return response.data.body;
}

const listDoc => async () => {
    const param: any = {
        command: "list",
        type: "doc",
        name: "test-index-01",
    };

  const response = await requestPost(param)
}`;

const response_code: string = `{
    "statusCode": 200,
    "body": {
        "status_code": 200,
        "error_msg": "",
        "rtn_msg": "success",
        "result": [
            {
                "score": 1.0,
                "id": 3,
                "text": "test3",
                "metadata": "202308031536",
                "embedding": ""
            },
            {
                "score": 1.0,
                "id": 5,
                "text": "test7",
                "metadata": "202308031547",
                "embedding": ""
            },
            {
                "score": 1.0,
                "id": 1,
                "text": "test",
                "metadata": "20230803",
                "embedding": ""
            },
            {
                "score": 1.0,
                "id": 4,
                "text": "test4",
                "metadata": "202308031547",
                "embedding": ""
            },
            {
                "score": 1.0,
                "id": 99,
                "text": "test99",
                "metadata": "202308031631",
                "embedding": ""
            },
            {
                "score": 1.0,
                "id": 2,
                "text": "test2",
                "metadata": "202308031500",
                "embedding": ""
            }
        ]
    }
}`;

const ListDocApi = (props: propsType) => {
  return (
    <Box className="info-main-content">
      <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <Box className="info-main-content-sub-root">
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography gutterBottom className="info-main-content-sub-title">
              List Documents
            </Typography>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Button
              variant="text"
              size="small"
              onClick={() => {
                props.move("top");
              }}
            >
              [TOP]
            </Button>
          </Box>
        </Box>
        <Divider sx={{ width: "100%" }} />
        <Typography gutterBottom className="info-main-request-body-text mt-20">
          인덱스에 추가한 도큐먼트 목록을 조회한다.
        </Typography>
        <Typography gutterBottom className="info-main-request-body-title mt-20">
          Request
        </Typography>
        <Box>
          <CodeBlock text={request_code} language={"typescript"} showLineNumbers={false} startingLineNumber={1} theme={dracula} />
        </Box>
        <Typography gutterBottom className="info-main-request-body-title mt-20">
          Parameters
        </Typography>
        <Typography gutterBottom className="info-main-request-body-text">
          • command (string) <span style={{ color: "red" }}>[REQUIRED]</span> : 목록조회 ("list")
        </Typography>
        <Typography gutterBottom className="info-main-request-body-text">
          • type (string) <span style={{ color: "red" }}>[REQUIRED]</span> : 도큐먼트 ("doc")
        </Typography>
        <Typography gutterBottom className="info-main-request-body-text">
          • name (string) <span style={{ color: "red" }}>[REQUIRED]</span> : 조회할 인덱스명.
        </Typography>
        <Typography gutterBottom className="info-main-request-body-title mt-20">
          Response
        </Typography>
        <Box>
          <CodeBlock text={response_code} language={"typescript"} showLineNumbers={false} startingLineNumber={1} theme={dracula} />
        </Box>
      </Box>
    </Box>
  );
};

export default ListDocApi;
